import { useGetTotalNewIdeasDateRangeQuery } from '../../../../../apis/statistics/statistics-api.api.ts'
import { EChartsOption } from 'echarts'
import { DashboardChartBox } from '../dashboard-chart-box.tsx'
import ReactECharts from 'echarts-for-react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from '../../../../../redux/hooks.ts'
import { selectDashboardInput } from '../../../../../redux/slices/dashboard-input.slice.ts'
import dayjs from 'dayjs'
import {
  selectTheme,
  selectThemeStyle,
} from '../../../../../features/setting/setting.slice.ts'
import { getEchartsTheme } from '../../../../../utils/helpers.ts'

interface TotalNewIDeasChartProps {
  bookId: string
}

export const TotalNewIdeasChart: React.FC<TotalNewIDeasChartProps> = ({
  bookId,
}) => {
  const { t } = useTranslation()
  const dashboardInput = useAppSelector(selectDashboardInput)
  const themeStyle = useAppSelector(selectThemeStyle)
  const colorTheme = useAppSelector(selectTheme)
  const echartsTheme = getEchartsTheme(colorTheme)
  const { data } = useGetTotalNewIdeasDateRangeQuery({
    bookId: bookId,
    startDate: dayjs(dashboardInput.dateRange[0]).format('YYYY-MM-DD'),
    endDate: dayjs(dashboardInput.dateRange[1]).format('YYYY-MM-DD'),
  })

  if (!data) return <></>

  const totalIdeas = data.data.long + data.data.short

  const chartOption: EChartsOption = {
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: 'center',
      bottom: 'bottom',
      textStyle: {
        color: themeStyle.sumText,
      },
    },
    series: [
      {
        name: '',
        type: 'pie',
        radius: ['60%', '70%'],
        data: [
          {
            value: data.data.long,
            name: t('idea_list.idea_table.direction.long'),
          },
          {
            value: data.data.short,
            name: t('idea_list.idea_table.direction.short'),
          },
        ],
        label: {
          show: false,
        },
      },
    ],
    graphic: {
      type: 'text',
      left: 'center',
      top: 'center',
      style: {
        text: `${totalIdeas} (${data.data.long} ${t('idea_list.idea_table.direction.long')}/\n${data.data.short} ${t(
          'idea_list.idea_table.direction.short'
        )})`,
        fill: themeStyle.sumText,
        fontSize: 16,
      },
    },
  }

  return (
    <DashboardChartBox title={t('dashboard.total_new_ideas')}>
      <ReactECharts option={chartOption} theme={echartsTheme.themeName} />
    </DashboardChartBox>
  )
}
